"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPrototypeExports = void 0;
var Utils_1 = require("../Utils");
var createPrototypeExports = function (config) {
    var _a, _b;
    var exports = {};
    (_b = (0, Utils_1.getKeys)((_a = config === null || config === void 0 ? void 0 : config.exports) !== null && _a !== void 0 ? _a : {})) === null || _b === void 0 ? void 0 : _b.forEach(function (expName) {
        var _a;
        var exp = (_a = config === null || config === void 0 ? void 0 : config.exports) === null || _a === void 0 ? void 0 : _a[expName];
        if (exp == undefined)
            return;
        exports[expName] = __assign(__assign({}, exp), { interfaces: processExportInterfaces(exp.interfaces) });
    });
    return exports;
};
exports.createPrototypeExports = createPrototypeExports;
var processExportInterfaces = function (int) {
    var newInterfaces = [];
    int.forEach(function (_a) {
        var interfaceId = _a.interfaceId, payload = _a.payload;
        newInterfaces.push({ interfaceId: interfaceId, payload: payload });
    });
    return newInterfaces;
};
//# sourceMappingURL=createPrototypeExports.js.map